import React, { Component } from 'react';

export const MOCK_SHOULD_ENABLE_TRUE = 'Mock should enable set to true';
export const MOCK_SHOULD_ENABLE_FALSE = 'Mock should enable set to false';
export const MOCK_CHANGE_ANSWER_VALUE = 'Mock change answer value';
export const MOCK_CREATE_ERROR = 'Mock create error';
export const ANSWER = 'a mocked answer';
export const ERROR_MESSAGE = 'a mocked error';

class MockWidget extends Component {
  state = { isError: false };

  errorChecking = async () => this.state.isError;

  render() {
    const { shouldEnable, changeAnswerValue, widget } = this.props;
    return (
      <div data-testid={widget}>
        {this.state.isError && <p>{ERROR_MESSAGE}</p>}
        <button onClick={() => shouldEnable(widget, true)}>
          {MOCK_SHOULD_ENABLE_TRUE}
        </button>
        <button onClick={() => shouldEnable(widget, false)}>
          {MOCK_SHOULD_ENABLE_FALSE}
        </button>
        <button onClick={() => changeAnswerValue(widget, ANSWER)}>
          {MOCK_CHANGE_ANSWER_VALUE}
        </button>
        <button onClick={() => this.setState({ isError: true })}>
          {MOCK_CREATE_ERROR}
        </button>
      </div>
    );
  }
}

export default MockWidget;
